import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneChangeValidator(fields: string[]): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    for (const field of fields) {
      const control = group.get(field);
      if (control && control.value) {
        return null;
      }
    }

    return { atLeastOneInput: true };
  };
}
